import AntdAlert, { type AlertProps as AntdAlertProps } from "antd/lib/alert";

export type AlertProps = AntdAlertProps;

export const Alert = (props: AlertProps) => {
    return <AntdAlert {...props} />;
};
